import { AxiosRequestConfig } from 'axios';

import { RequestsInstance } from '../../../api';
import { BonusesAndFreebetsQuery, BonusesAndFreebetsResponse } from '../interface/api.interface';

const OffersApiWrapper = (requests: RequestsInstance) => {
	return {
		getCancelOfferOnWithdrawal: () => {
			return requests.get(`offers/cancel/withdrawal`);
		},

		getBonusesAndFreebets: (params: BonusesAndFreebetsQuery = {}) => {
			return requests.get<BonusesAndFreebetsResponse>(`offers/bonus-and-freebets`, { params });
		},

		getBonusData: (queryParams: any) => {
			const config: AxiosRequestConfig = {
				params: queryParams,
			};
			return requests.get(`offers/bonus`, config);
		},

		getFreebetData: (queryParams: any) => {
			const config: AxiosRequestConfig = {
				params: queryParams,
			};
			return requests.get(`offers/freebet`, config);
		},

		activateBonus: (queueId: number) => {
			return requests.post(`offers/bonus/activate/${queueId}`);
		},

		rejectBonus: (queueId: number) => {
			return requests.post(`offers/bonus/reject/${queueId}`);
		},

		waiveBonus: (offerId: number) => {
			return requests.delete(`offers/bonus/${offerId}`);
		},
	};
};

export default OffersApiWrapper;
